import React, { useState } from 'react';
import { IconButton, Tooltip, Typography } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';

export default function CopyableValue({ label, value, href }) {
  const [copied, setCopied] = useState(false);
  const displayValue = value == null || value === '' ? '—' : String(value);
  const canCopy = displayValue !== '—';

  const handleCopy = (e) => {
    e.stopPropagation();
    if (!canCopy) return;
    navigator.clipboard.writeText(displayValue).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  const valueContent = href && canCopy ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      style={{ color: 'inherit', textDecoration: 'none' }}
    >
      {displayValue}
    </a>
  ) : (
    displayValue
  );

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        marginBottom: 2,
      }}
    >
      <Typography
        component="span"
        variant="caption"
        style={{ minWidth: 52, color: '#666' }}
      >
        {label}
      </Typography>
      <span
        onClick={canCopy ? handleCopy : undefined}
        style={{
          fontFamily: 'monospace',
          fontSize: 12,
          backgroundColor: '#f5f5f5',
          borderRadius: 4,
          padding: '2px 6px',
          cursor: canCopy ? 'copy' : 'default',
        }}
      >
        {valueContent}
      </span>
      {canCopy && (
        <Tooltip title={copied ? 'Copied!' : 'Copy'}>
          <IconButton size="small" onClick={handleCopy} style={{ padding: 2 }}>
            <FileCopyIcon style={{ fontSize: 14 }} />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
}
